import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ChangeDetectorRef, OnInit } from '@angular/core';
import {Actions, ofType } from '@ngrx/effects';
import * as overviewActions from "@overview/actions/overview";
import {takeUntil, tap } from 'rxjs';
import {OnDestroySubject} from "@common/components/on-destroy-subject";

@Component({
  selector: 'mojo-overview-item',
  templateUrl: './overview-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewItemComponent
  extends OnDestroySubject
  implements OnInit, OnChanges {

  @Input() allowNavigation: boolean = true;
  @Input() showNumber: boolean;
  @Input() number: number;
  @Input() label: string;
  @Input() active: boolean;
  @Input() route: string;
  @Input() backgroundClass: string;
  @Input() queryParams: any;

  constructor(
    private readonly actions$: Actions,
    private readonly cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.actions$.pipe(
      ofType<overviewActions.Load>(overviewActions.LOAD),
      tap(_ => {
        this.setBlankNumber();
        this.disallowNavigation();
      }),
      takeUntil(this.destroy$)
    ).subscribe()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allowNavigation ||
        changes.showNumber ||
        changes.number ||
        changes.label ||
        changes.active ||
        changes.route ||
        changes.backgroundClass ||
        changes.queryParams) {
      this.cd.markForCheck();
    }
  }

  setBlankNumber() {
    this.number = undefined;
    this.cd.markForCheck();
  }

  disallowNavigation() {
    this.allowNavigation = false;
    this.cd.markForCheck();
  }
}
